<template>
  <v-container fill-height>
    <v-row align="center" class="fill-height ma-0" justify="center">
      <ResHubLogo />
    </v-row>
    <v-row>
      <v-col lg="12">
        <h3 align="center" class="mt-5">
          <b>
            {{ message }}
          </b>
        </h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ResHubLogo from "@/views/login/ResHubLogo.vue";

export default {
  components: {
    ResHubLogo
  },
  created() {
    const isIos = !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
    const isIosOrMac = !!navigator.userAgent.match(/iPhone|iPad|iPod|Macintosh/i);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !/CriOS/i.test(navigator.userAgent);

    if (isIos && !isSafari) {
      this.message = this.$t('AppLink.PleaseOpenInSafari')
    } 
    else if (isIosOrMac && isSafari) {
      this.message = this.$t('AppLink.MessageForSafary')
    }
    else {
      this.message = this.$t('AppLink.PleaseOpenOnAMobileDevice')
    }
  },
  data() {
    return {
      message: ''
    };
  }
};
</script>
